/* Karusan — línea "mt2": banner con video ligado directamente a la posición
   de scroll (sin bloquear la página, sin autoplay temporizado). */
(function () {
  function initHeroScrollVideo() {
    var secciones = document.querySelectorAll('[data-mt2-hero-scroll]');
    if (!secciones.length) return;

    var prefiereMenosMovimiento = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    secciones.forEach(function (seccion) {
      var video = seccion.querySelector('.mt2-video');
      var track = seccion.querySelector('[data-mt2-track]');
      var captions = Array.prototype.slice.call(
        seccion.querySelectorAll('[data-mt2-caption]')
      );
      var puntos = Array.prototype.slice.call(
        seccion.querySelectorAll('[data-mt2-punto]')
      );

      if (!video || !track) return;

      if (prefiereMenosMovimiento || !('IntersectionObserver' in window)) {
        seccion.classList.add('mt2-estatico');
        if (captions.length) captions[0].classList.add('is-active');
        return;
      }

      var listo = false;
      var objetivo = 0;
      var actual = -1;
      var necesitaActualizar = false;

      // iOS Safari solo permite mover currentTime por script si el video
      // ya ha sido "desbloqueado" con un play/pause real.
      function desbloquearIOS() {
        var promesa = video.play();
        if (promesa && promesa.then) {
          promesa.then(function () { video.pause(); }).catch(function () {});
        }
      }

      function alCargar() {
        listo = true;
        desbloquearIOS();
        actualizarProgreso();
      }

      if (video.readyState >= 1) {
        alCargar();
      } else {
        video.addEventListener('loadedmetadata', alCargar, { once: true });
      }

      function calcularProgreso() {
        var rect = track.getBoundingClientRect();
        var alturaDisponible = track.offsetHeight - window.innerHeight;
        if (alturaDisponible <= 0) return 0;
        var avanzado = -rect.top;
        var progreso = avanzado / alturaDisponible;
        return Math.min(1, Math.max(0, progreso));
      }

      function actualizarCaptions(progreso) {
        captions.forEach(function (caption) {
          var inicio = parseFloat(caption.dataset.rangeStart || '0');
          var fin = parseFloat(caption.dataset.rangeEnd || '1');
          caption.classList.toggle('is-active', progreso >= inicio && progreso <= fin);
        });
        var indiceActivo = -1;
        captions.forEach(function (caption, i) {
          var inicio = parseFloat(caption.dataset.rangeStart || '0');
          var fin = parseFloat(caption.dataset.rangeEnd || '1');
          if (progreso >= inicio && progreso <= fin) indiceActivo = i;
        });
        puntos.forEach(function (punto, i) {
          punto.classList.toggle('is-active', i === indiceActivo);
        });
      }

      function actualizarProgreso() {
        necesitaActualizar = false;
        objetivo = calcularProgreso();
        actualizarCaptions(objetivo);

        if (!listo || !video.duration || isNaN(video.duration)) return;

        var tiempoObjetivo = objetivo * video.duration;
        if (Math.abs(tiempoObjetivo - actual) > 0.01) {
          actual = tiempoObjetivo;
          try {
            video.currentTime = tiempoObjetivo;
          } catch (e) {
            /* el navegador puede rechazar un seek si aún no hay datos */
          }
        }
      }

      function pedirActualizacion() {
        if (necesitaActualizar) return;
        necesitaActualizar = true;
        requestAnimationFrame(actualizarProgreso);
      }

      window.addEventListener('scroll', pedirActualizacion, { passive: true });
      window.addEventListener('resize', pedirActualizacion);
      pedirActualizacion();
    });
  }

  function initTiltMt2() {
    var wraps = document.querySelectorAll('[data-mt2-tilt]');
    if (!wraps.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;

    wraps.forEach(function (wrap) {
      var marco = wrap.querySelector('.mt2-banner__marco');
      if (!marco) return;
      wrap.addEventListener('mousemove', function (e) {
        var rect = wrap.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        marco.style.setProperty('--mt2-tilt-x', (y * -10).toFixed(2) + 'deg');
        marco.style.setProperty('--mt2-tilt-y', (x * 10).toFixed(2) + 'deg');
      });
      wrap.addEventListener('mouseleave', function () {
        marco.style.setProperty('--mt2-tilt-x', '0deg');
        marco.style.setProperty('--mt2-tilt-y', '0deg');
      });
    });
  }

  function activarEntrada(el) {
    el.classList.add('mt2-visible');
    if (!el.classList.contains('mt2-reveal-stagger')) return;
    var hijos = el.children;
    var PASO_MS = 70;
    var DURACION_MS = 650;
    for (var i = 0; i < hijos.length; i++) {
      var hijo = hijos[i];
      var retraso = i * PASO_MS;
      hijo.style.transitionDelay = retraso + 'ms';
      (function (hijo, retraso) {
        setTimeout(function () {
          hijo.style.transitionDelay = '';
        }, retraso + DURACION_MS + 50);
      })(hijo, retraso);
    }
  }

  function initReveal() {
    var els = document.querySelectorAll('.mt2-reveal, .mt2-reveal-stagger');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(activarEntrada);
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activarEntrada(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initFaqMt2() {
    document.querySelectorAll('.mt2-faq__lista').forEach(function (lista) {
      var items = lista.querySelectorAll('.mt2-faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) {
            items.forEach(function (otro) {
              if (otro !== item) otro.removeAttribute('open');
            });
          }
        });
      });
    });
  }

  function initTodo() {
    initHeroScrollVideo();
    initReveal();
    initFaqMt2();
    initTiltMt2();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
})();
